(function($, undefined) {

	/**
	 * Extension zajišťující správné odeslání pomocí klávesy enter v případě formuláře s více submit tlačítky.
	 * Pro input, ve kterém došlo ke zmáčknutí enteru, najde submit button uvnitř společného ".find-closest" a odešle
	 * formulář pomocí tohoto tlačítka.
	 */
	$.nette.ext('enterSubmit', {
		init: function() {
			var snippetsExt = this.ext('snippets', true);
			var ext = this;

			snippetsExt.after(function($el) {
				ext.init.call(ext, $el);
			});

			this.init($(document));
		}
	}, {
		selector: '.js-enter-submit',
		delay: 3000,
		init: function($el) {
			var ext = this;
			var $els = $el.find(this.selector);

			$els.on('keypress', '.inp-text', function (e) {
				if (e.keyCode !== 13) {
					return event.keyCode;
				}
				else {
					var $btn = $(e.delegateTarget).find('input[type="submit"], button[type="submit"], input[type="image"]');

					if ($btn.length) {
						$btn.trigger('click');
						return false;
					}
				}
			});
		}
	});

})(jQuery);
